import type { FaqItem } from '../components/ds';
import type { ProductPipelineMigrate } from './productShared';

export const SHOT_CONTROL_FAQ: readonly FaqItem[] = [
  {
    q: 'Does overriding a shot change the rest of the cut?',
    a: 'No. Overrides are local — Induce re-generates only the shot you\'re changing and leaves the rest untouched, so the cut you\'ve approved stays safe.',
  },
  {
    q: 'What can I override?',
    a: 'Six things on any shot: angle and framing, lens and depth, lighting, pacing, performance, and blocking. Describe the change in plain language, or set parameters directly.',
  },
  {
    q: 'Will an override break continuity?',
    a: 'No. Every override runs back through the Coherence Verifier — checked against the Project Memory Graph and the Cinematic Constitution — so character identity, location look, and the grammar of the cut all hold.',
  },
  {
    q: 'What happens when a shot fails verification?',
    a: 'Rhapsody names the rule or continuity link that broke, re-plans the shot, and queues a targeted re-generation. Nothing enters the cut without passing verification and your sign-off.',
  },
];

export const PIPELINE_MIGRATE: ProductPipelineMigrate = {
  kicker: '- Next in the pipeline',
  title: 'Continuity holds your film together. Shot control lets you shape each frame.',
  body: 'Override any shot — angle, lens, lighting, blocking, performance — without breaking the continuity of the scenes around it. Every override re-verified.',
  ctaLabel: 'Shot Control',
  ctaTo: '/product/shot-control',
} as const;
